import { render, staticRenderFns } from "./LoaderBox.vue?vue&type=template&id=00f4962f&scoped=true&"
import script from "./LoaderBox.vue?vue&type=script&lang=js&"
export * from "./LoaderBox.vue?vue&type=script&lang=js&"
import style0 from "./LoaderBox.vue?vue&type=style&index=0&id=00f4962f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4962f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VProgressCircular})
